import { BrowserRouter, Routes, Route } from "react-router-dom";
import React, { Fragment } from "react";
import "./App.css";
import Home from "./pages/Home";
import NavBars from "./components/NavBars";
import About from "./pages/About";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Help from "./pages/Help";
import Contect from "./pages/Contect";
import Register from "./pages/Register";
import ForgetPassword from "./pages/ForgetPassword";
import EnterCode from "./pages/EnterCode";
import ResetPassword from "./pages/ResetPassword";
import ResetSuccessfully from "./pages/ResetSuccessfully";
import "bootstrap/dist/css/bootstrap.min.css";
import FindOutMore from "./pages/FindOutMore";
import PaymentDetails from "./pages/PaymentDetails";
import SetupDirectDebit from "./pages/SetupDirectDebit";
import OneOffServices from "./pages/OneOffServices";
import NewBoiler from "./pages/NewBoiler";
import BoilerRepai from "./pages/BoilerRepai";
import Dashboard from "./dashboard/Dashboard";
import BookRepair from "./dashboard/BookRepair";
import CheckUser from "./dashboard/CheckUser";
import OneOffRepair from "./pages/OneOffRepair";
import ONeOffPaymentDetails from "./pages/ONeOffPaymentDetails";
import NotFound from "./pages/Nopage";
import Cookies from "./pages/Cookies";
import Complaints from "./pages/ComplaintsProcedure";
import ScrollToTop from "./components/ScrollToTop";
import AuthChecker from "./components/AuthChecker";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Fragment>
          <NavBars />
          <ScrollToTop />

            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/About" element={<About />} />
              <Route path="/Terms" element={<Terms />} />
              <Route path="/Privacy" element={<Privacy />} />
              <Route path="/Help" element={<Help />} />
              <Route path="/Login" element={<CheckUser />} />
              <Route path="/Register" element={<Register />} />
              <Route path="/Contect" element={<Contect />} />
              <Route path="/ForgetPassword" element={<ForgetPassword />} />
              <Route path="/EnterCode" element={<EnterCode />} />
              <Route path="/ResetPassword" element={<ResetPassword />} />
              <Route
                path="/ResetSuccessfully"
                element={<ResetSuccessfully />}
              />
              <Route path="/FindOutMore/:id" element={<FindOutMore />} />
              <Route
                path="/PaymentDetails/:paymenId/:id"
                element={<PaymentDetails />}
              />
              <Route
                path="/SetupDirectDebit/:paymenId/:id"
                element={<SetupDirectDebit />}
              />
              <Route path="/OneOffServices" element={<OneOffServices />} />
              <Route path="/NewBoiler" element={<NewBoiler />} />
              <Route path="/BoilerRepai" element={<BoilerRepai />} />
              {/* <Route path="/Dashboard" element={<PrivateRoute />}>
              <Route path="/Dashboard" element={<Dashboard />} exact />
              </Route> */}
              {/* <Route path="/dashboard" element={<PrivateRoute />}> */}
              <Route path="/dashboard" caseSensitive element={<Dashboard />} />
              {/* </Route> */}
              <Route path="/BookRepair" element={<BookRepair />} />
              <Route path="/CheckUser" element={<CheckUser />} />
              <Route path="/OneOffRepair/:id" element={<OneOffRepair />} />
              <Route path="/Cookies" element={<Cookies />} />
              <Route path="/Complaints" element={<Complaints />} />
              <Route
                path="/ONeOffPaymentDetails/:paymenId/:id"
                element={<ONeOffPaymentDetails />}
              />
              <Route path="*" element={<NotFound />} />
            </Routes>

        </Fragment>
      </BrowserRouter>
    </div>
  );
}

export default App;
